// Mock data for WBL Services website

export const COMPANY = {
  name: "WBL Services",
  tagline: "NETTOYAGE \u00b7 TOULOUSE",
  slogan: "Nettoyage professionnel \u00e0 Toulouse",
  phone: "+33 7 49 83 09 05",
  phoneRaw: "+33749830905",
  whatsapp: "+33 7 49 62 54 00",
  whatsappRaw: "33749625400",
  whatsappMsg: "Bonjour, je suis int\u00e9ress\u00e9(e) par vos services de nettoyage.",
  email: "contact@wbl-services.fr",
  address: "22 rue Cafarelli, 31000 Toulouse",
  logo: "/logo.png",
};

export const NAV_LINKS = [
  { label: "Accueil", path: "/" },
  { label: "Services", path: "/services" },
  { label: "\u00c0 propos", path: "/a-propos" },
  { label: "Contact", path: "/contact" },
];

export const HERO = {
  titlePlain: "Un nettoyage ",
  titleAccent: "professionnel",
  titleRest: " pour que vous puissiez vous concentrer sur l'essentiel.",
  subtitle:
    "\u00c0 Toulouse et ses environs, WBL Services prend en charge le nettoyage de votre maison, de vos bureaux et de votre linge \u2014 avec la rigueur de 30 ans d'exp\u00e9rience.",
  bullets: [
    "Devis gratuit & sans engagement",
    "Satisfaction garantie",
    "Intervention rapide",
  ],
  image:
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1400&q=80",
};

export const STATS = [
  { value: "30", suffix: "ans", label: "d'expertise dans le nettoyage professionnel" },
  { value: "100%", suffix: "", label: "satisfaction garantie ou nous revenons" },
  { value: "9", suffix: "services", label: "sp\u00e9cialis\u00e9s pour particuliers et professionnels" },
  { value: "0\u20ac", suffix: "", label: "le devis est gratuit et sans engagement" },
];

export const SERVICE_PREVIEWS = [
  {
    icon: "Sparkles",
    title: "Nettoyage d'entretien",
    desc: "Un nettoyage r\u00e9gulier, fiable et minutieux pour un environnement toujours impeccable.",
  },
  {
    icon: "Building2",
    title: "Nettoyage de bureaux",
    desc: "Un bureau impeccable qui inspire confiance et booste la productivit\u00e9.",
  },
  {
    icon: "Truck",
    title: "Nettoyage de d\u00e9m\u00e9nagement",
    desc: "D\u00e9m\u00e9nagez l'esprit tranquille avec notre garantie de remise des cl\u00e9s.",
  },
  {
    icon: "HardHat",
    title: "Nettoyage de chantier",
    desc: "Apr\u00e8s travaux : poussi\u00e8re, traces et r\u00e9sidus disparaissent int\u00e9gralement.",
  },
  {
    icon: "AppWindow",
    title: "Nettoyage de vitres",
    desc: "Des vitres claires et brillantes, sans traces, \u00e0 l'int\u00e9rieur comme \u00e0 l'ext\u00e9rieur.",
  },
  {
    icon: "Home",
    title: "Nettoyage de maison",
    desc: "Nettoyage complet de votre maison : sols, surfaces, sanitaires, cuisine \u2014 repassage et lessive inclus sur demande.",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Remplir le formulaire",
    desc: "D\u00e9crivez-nous bri\u00e8vement vos besoins via notre formulaire de contact.",
  },
  {
    num: "02",
    title: "Premier entretien",
    desc: "Vous recevez rapidement un appel direct pour pr\u00e9ciser votre demande.",
  },
  {
    num: "03",
    title: "Recevoir le devis",
    desc: "Un devis personnalis\u00e9, clair et sans engagement, vous est envoy\u00e9.",
  },
];

export const TESTIMONIALS = [
  {
    text: "Votre avis pourrait appara\u00eetre ici. Faites-nous part de votre exp\u00e9rience apr\u00e8s notre intervention.",
    author: "Client WBL Services",
  },
  {
    text: "Votre avis pourrait appara\u00eetre ici. Faites-nous part de votre exp\u00e9rience apr\u00e8s notre intervention.",
    author: "Client WBL Services",
  },
  {
    text: "Votre avis pourrait appara\u00eetre ici. Faites-nous part de votre exp\u00e9rience apr\u00e8s notre intervention.",
    author: "Client WBL Services",
  },
];

export const SERVICES_FULL = [
  {
    num: "01",
    icon: "Sparkles",
    title: "Nettoyage d'entretien",
    desc: "Un entretien r\u00e9gulier et rigoureux de vos espaces professionnels ou communs. Nous assurons une pr\u00e9sence fiable et discr\u00e8te pour maintenir vos locaux impeccables au quotidien.",
    points: ["Bureaux & espaces communs", "Cages d'escalier", "Cabinets & \u00e9tudes", "Locaux commerciaux"],
  },
  {
    num: "02",
    icon: "Building2",
    title: "Nettoyage de bureaux",
    desc: "Un environnement de travail sain et accueillant qui inspire confiance \u00e0 vos clients et stimule la productivit\u00e9 de vos \u00e9quipes.",
    points: ["Postes de travail", "Sanitaires", "Cuisines & coins caf\u00e9", "Espaces d'accueil"],
  },
  {
    num: "03",
    icon: "Truck",
    title: "Nettoyage de d\u00e9m\u00e9nagement",
    desc: "Un nettoyage complet en fin de bail pour r\u00e9cup\u00e9rer votre caution ou remettre les cl\u00e9s l'esprit tranquille.",
    points: ["Garantie de remise", "Cuisine & salle de bain", "Fen\u00eatres & cadres", "Sols & murs"],
  },
  {
    num: "04",
    icon: "HardHat",
    title: "Nettoyage de chantier",
    desc: "Apr\u00e8s vos travaux de construction ou de r\u00e9novation, nous \u00e9liminons poussi\u00e8res, r\u00e9sidus et traces pour un rendu final impeccable.",
    points: ["Nettoyage grossier", "Nettoyage fin", "Nettoyage final", "\u00c9limination de la poussi\u00e8re"],
  },
  {
    num: "05",
    icon: "AppWindow",
    title: "Nettoyage de vitres",
    desc: "Des surfaces vitr\u00e9es parfaitement transparentes, sans traces ni r\u00e9sidus, pour laisser entrer toute la lumi\u00e8re.",
    points: ["Surfaces vitr\u00e9es", "Cadres & feuillures", "Vitrines commerciales", "V\u00e9randas"],
  },
  {
    num: "06",
    icon: "Home",
    title: "Nettoyage de maison",
    desc: "Un nettoyage complet de votre foyer, pi\u00e8ce par pi\u00e8ce, avec repassage et lessive inclus sur demande pour un quotidien all\u00e9g\u00e9.",
    points: [
      "Toutes les pi\u00e8ces",
      "Sanitaires d\u00e9tartr\u00e9s",
      "Cuisine d\u00e9graiss\u00e9e",
      "Sols & surfaces",
      "Repassage du linge",
      "Lessive : lavage, s\u00e9chage, pliage",
      "Changement des draps & lits faits",
      "D\u00e9poussi\u00e9rage & vitres int\u00e9rieures",
    ],
  },
  {
    num: "07",
    icon: "Shirt",
    title: "Lavage et repassage classique",
    desc: "Confiez-nous votre linge : nous le lavons, le s\u00e9chons et le repassons avec soin pour un r\u00e9sultat net et pr\u00eat \u00e0 porter.",
    points: ["Lavage soign\u00e9", "S\u00e9chage adapt\u00e9", "Pliage net", "Lessives de qualit\u00e9"],
  },
  {
    num: "08",
    icon: "Droplets",
    title: "Repassage et nettoyage en profondeur",
    desc: "Un nettoyage en profondeur qui s'attaque aux moindres recoins, pour redonner \u00e9clat et fra\u00eecheur \u00e0 votre int\u00e9rieur.",
    points: ["Joints & plinthes", "Four & frigo int\u00e9rieurs", "D\u00e9tartrage robinetterie", "Repassage minutieux"],
  },
  {
    num: "09",
    icon: "Wind",
    title: "Repassage fer et blanchisserie",
    desc: "Un service de blanchisserie complet avec finitions soign\u00e9es pour votre linge de maison et vos v\u00eatements du quotidien.",
    points: ["Chemises & chemisiers", "Pantalons & jupes", "Linge de maison", "Finitions soign\u00e9es"],
  },
];

export const ABOUT = {
  heading: "WBL Services \u2014 l'excellence du nettoyage \u00e0 Toulouse.",
  intro:
    "Avec plus de 30 ans d'exp\u00e9rience, WBL Services accompagne les particuliers et les professionnels de Toulouse et de ses environs dans l'entretien quotidien de leurs espaces. Nous veillons \u00e0 ce que vos lieux de vie et de travail restent impeccables, sans stress et sans compromis sur la qualit\u00e9.",
  paragraphs: [
    "Fond\u00e9e sur une conviction simple \u2014 la propret\u00e9 est un acte de respect \u2014 WBL Services s'est impos\u00e9e au fil des ann\u00e9es comme un partenaire de confiance pour des centaines de foyers, bureaux et chantiers \u00e0 Toulouse.",
    "Nous mettons un point d'honneur \u00e0 former une \u00e9quipe stable et fiable, capable d'intervenir avec la m\u00eame exigence sur un appartement, un open-space ou un chantier de r\u00e9novation. Nos clients nous confient leurs cl\u00e9s parce qu'ils savent qu'\u00e0 notre passage, tout sera comme il faut : propre, rang\u00e9, soign\u00e9.",
    "Au-del\u00e0 du nettoyage classique, nous proposons des prestations sp\u00e9cialis\u00e9es \u2014 blanchisserie, repassage, nettoyage en profondeur, fin de chantier \u2014 pour r\u00e9pondre \u00e0 tous les besoins d'un foyer ou d'une entreprise. Une seule \u00e9quipe, un seul interlocuteur.",
  ],
  images: [
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?auto=format&fit=crop&w=900&q=80",
  ],
  pillars: [
    {
      icon: "Award",
      title: "30 ans d'exp\u00e9rience",
      desc: "Trois d\u00e9cennies d'expertise dans le nettoyage professionnel et l'entretien des b\u00e2timents.",
    },
    {
      icon: "HeartHandshake",
      title: "Service personnalis\u00e9",
      desc: "Chaque client est unique : nous adaptons nos prestations \u00e0 vos besoins, votre rythme et vos exigences.",
    },
    {
      icon: "Search",
      title: "Exigence du d\u00e9tail",
      desc: "Nous portons une attention obsessionnelle aux finitions. Le diable se cache dans les d\u00e9tails \u2014 nous aussi.",
    },
  ],
  gallery: [
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1563453392212-326f5e854473?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?auto=format&fit=crop&w=900&q=80",
  ],
};
